<template>
  <div class="login-page">
    <!-- 背景图片 -->
    <!-- <background-image></background-image> -->
    <!-- 登录面板 -->
    <div class="login-body">
      <!-- logo图片 -->
      <!-- <logo-image></logo-image> -->
      <div class="logo_big">
        <img class="logo-image" src="../assets/img/shiji-logo-v2.png" />
      </div>
      <div class="logo_small">
        <img class="logo-image" src="../assets/img/shiji-logo-white.png" />
      </div>
      <div>
        <!-- 登录文字 -->
        <div class="login-text">
          <h1 class="login-h1" v-show="currentLocale == 'en'">
            Log Out Completed.
          </h1>
          <h1 class="login-h1" v-show="currentLocale == 'zh'">注销已完成.</h1>
        </div>
      </div>
      <!-- 按钮 -->
      <div>
        <button
          ref="button"
          type="submit"
          class="loginButton"
          @click="goToLogin"
          style="width: 150px"
        >
          <span v-show="currentLocale == 'en'">Go to login</span>
          <span v-show="currentLocale == 'zh'">转到登录</span>
        </button>
      </div>
      <!-- 登录脚部 -->
      <feet></feet>
    </div>
  </div>
</template>
<script>
import feet from "../components/Feet.vue";
import {
  LOGIN_API,
  SIS_TOKEN_API,
  NORMAL_IDENTITY_TITLE,
  IDENTITY_ADDRESS,
  SEP_IDENTITY_TITLE,
  USER_TYPE_API,
} from "../../config-json.js";
export default {
  components: {
    // logoImage,
    feet,
  },
  data() {
    return {
      currentLocale: this.$cookies.get(SEP_IDENTITY_TITLE + "-" + "locale")
        ? this.$cookies.get(SEP_IDENTITY_TITLE + "-" + "locale")
        : "zh",
    };
  },
  created() {
    this.$cookies.remove(SEP_IDENTITY_TITLE + "-" + "SEP_access_token");
  },
  methods: {
    goToLogin() {
      this.$router.replace("/");
    },
  },
};
</script>

<style scoped>
.sis-style {
  cursor: pointer;
}
@media (max-width: 768px) {
  .login-page {
    background: url("../assets/img/applet.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
  }
  .login-h1 {
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 8px;
    color: #ffff;
  }
  .login-text {
    height: 15rem;
    color: #ffff;
  }
  .label-size {
    display: inline-block;
    order: 0;
    margin: 4px 0;
    font-size: 13px;
    line-height: 1.27;
    color: #ffff;
  }
  .el-checkbox {
    display: inline-block;
    padding-left: 10px;
    line-height: 19px;
    font-size: 14px;
    color: #ffff !important;
  }
  .ac-field {
    padding: 5px 0;
    flex-direction: column;
    text-align: left;
  }
  .logo_big {
    display: none;
  }
  .logo_small {
    width: 84px;
    height: 44px;
    box-sizing: border-box;
    margin-bottom: 16px;
  }
}
@media (min-width: 768px) {
  .login-text {
    height: 15rem;
  }
  .logo_small {
    display: none;
  }
  .logo_big {
    width: 84px;
    height: 44px;
    box-sizing: border-box;
    margin-bottom: 16px;
  }
  .login-page {
    background: url("../assets/img/web.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
  }
  .login-page .login-body {
    position: absolute;
    justify-content: space-between;
    top: 50%;
    left: 50%;
    width: 490px;
    height: auto;
    min-height: 660px;
    max-height: 95vh;
    transform: translate(-50%, -50%);
    overflow-y: auto;
    padding: 40px 48px;
    box-shadow: 0 1px 4px rgb(0 0 0 / 50%);
  }
}
.enter-login {
  font-size: 13px;
  font-weight: 400;
}
.login-footer {
  margin-top: 150px;
  border-top: 2px solid #bdbdbd;
}
.succeeded {
  font-size: 27px;
  font-weight: 400;
  margin-bottom: 200px;
}
</style>
